// Titoli EA FC e cambio club tra un titolo e l'altro.
//
// A ogni uscita EA riparte da zero con i club Pro Clubs: il team ricollega il
// club nuovo e lo storico resta. Per questo ogni partita salvata ricorda per
// quale club e' stata scaricata (`our_club_id`, scritto da sync-ea-club) e di
// quale titolo e' (`ea_game`): "la nostra squadra" dentro una partita va
// cercata con quell'id, non con quello collegato oggi al team.

// Allineato a public.current_ea_game() (migration 20260919000100): vanno
// aggiornati insieme a ogni nuova uscita.
export const CURRENT_EA_GAME = "fc27";

// "fc27" -> "FC 27"
export function eaGameLabel(game: string | null | undefined): string {
  const m = /^fc(\d{2})$/i.exec(game || "");
  return m ? `FC ${m[1]}` : (game || "").toUpperCase();
}

// Il team e' collegato al club di un titolo precedente: il sync e' fermo
// finche' non si collega il club nuovo.
export function isLegacyEaLink(team: { ea_club_id?: string | null; ea_game?: string | null }): boolean {
  return !!team.ea_club_id && !!team.ea_game && team.ea_game !== CURRENT_EA_GAME;
}

// Id del nostro club dentro una partita salvata. Una riga senza
// `our_club_id` (caso residuo: il backfill le ha marcate tutte) ricade
// sull'id collegato oggi al team.
export function ourClubIdOf(matchData: any, fallbackClubId: string): string {
  const stored = matchData?.our_club_id;
  return stored ? String(stored) : fallbackClubId;
}

// Titolo di una partita salvata (null se sconosciuto).
export function eaGameOf(matchData: any): string | null {
  return matchData?.ea_game ? String(matchData.ea_game) : null;
}
